import { render, staticRenderFns } from "./payCheck.vue?vue&type=template&id=0630a486&scoped=true&"
import script from "./payCheck.vue?vue&type=script&lang=js&"
export * from "./payCheck.vue?vue&type=script&lang=js&"
import style0 from "./payCheck.vue?vue&type=style&index=0&id=0630a486&prod&scoped=true&lang=css&"
import style1 from "./payCheck.vue?vue&type=style&index=1&id=0630a486&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0630a486",
  null
  
)

export default component.exports